import { useEffect } from 'react';

import { uiStore } from '../../core/stores/ui-store';

export const SecurityPage = () => {
  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Password and authentication',
    };

    uiStore.showBack = true;
  }, []);

  return (
    <div>
      <h2>Security</h2>
      <p>Account security is managed in your CREE8 account.</p>
    </div>
  );
};
